// extracted by mini-css-extract-plugin
module.exports = {"button":"Icon_button__Caz3X","green":"Icon_green__tL4G5","red":"Icon_red__1XzHD","rotate":"Icon_rotate__1lKdt"};